import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './datatable.scss';

const CustomDataTable = ({
    value,
    showGridlines = true,
    paginator = true,
    rows,
    dataKey = "id",
    filters,
    filterDisplay = "row",
    loading,
    globalFilterFields,
    header,
    emptyMessage = "No data found.",
    columns,
    first,
    onPageChange,
    archiveKey,
    onFilter,
    isServerSide
}) => {
    const rowClassName = (data) => (data[archiveKey] === 'archive' ? 'archiveRowColor' : '');
    return (
        <>
            <DataTable
                value={value}
                showGridlines={showGridlines}
                paginator={paginator}
                paginatorTemplate=" "
                rows={rows}
                first={isServerSide ? '' : first}
                onPage={onPageChange}
                dataKey={dataKey}
                filters={isServerSide ? '' : filters}
                filterDisplay={filters ? filterDisplay : undefined}
                loading={loading}
                globalFilterFields={filters ? globalFilterFields : undefined}
                header={header ? header : undefined}
                emptyMessage={emptyMessage}
                rowClassName={rowClassName ? rowClassName : ""}
                // onFilter={ isServerSide ? onFilter : ''}
                onFilter={ onFilter || '' }
                
            >
                {columns.map((col, index) => {
                    return <Column
                        key={index}
                        sortable={col.sortable}
                        field={col.field}
                        header={col.header}
                        filter={col.filter}
                        filterField={col.filter ? col.filterField : undefined}
                        filterDisplay={col.filter ? col.filterDisplay : undefined}
                        filterPlaceholder={col.filter ? col.filterPlaceholder : undefined}
                        showFilterMenu={col.filter ? col.showFilterMenu : undefined}
                        filterMenuStyle={col.filter ? col.filterMenuStyle : undefined}
                        style={col.style}
                        body={col.body}
                        filterElement={col.filter ? col.filterElement : undefined}
                        dataType={col.dataType}
                        className='tr-rows'
                    />
})}
            </DataTable>
        </>
    );
};

export default CustomDataTable;
